import React, { useEffect, useState } from "react";
import imgArrow from '../../../assets/siteManagement/images/arrow-1.svg'
import ArrowIcon from "../../site_management/icons/ArrowIcon";

function ButtonBack(props) {
    const [detailBtn, setDetailBtn] = useState({
        Text: '',
    })

    useEffect(() => {
        if (props.text) {
            let detail = {
                ...detailBtn,
                Text: props.text,
            }
            setDetailBtn(detail);
        }
    }, [props.text])

    function onClickButton() {
        try {
            props.onClick();
        } catch { }
    }

    return (
        <div className={`
        py-1.5 px-4 
        flex justify-center items-center 
        cursor-pointer
        rounded-lg
        hover:bg-vekin-primary/40 duration-300 ease-in-out
        bg-vekin-primary-opacity10
        `}
            onClick={(e) => { onClickButton() }}
        >
            {/* <img className="w-4 h-3.5 mr-2" src={imgArrow} /> */}
            <ArrowIcon className="w-4 h-3.5 mr-2 text-vekin-primary-dark" />
            <p className={`text-vekin-primary-dark text-xs font-semibold`}>
                {detailBtn.Text}
            </p>
        </div>
    )
}

export default ButtonBack;